import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
  Link,
  useNavigate,
  useLocation
} from 'react-router-dom';

// Impor semua halaman yang sudah jadi
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import InvoiceList from './pages/InvoiceList';
import InvoiceForm from './pages/InvoiceForm';
import Report from './pages/Report';
import InvoicePreview from './pages/InvoicePreview'; // <-- HALAMAN BARU DIIMPOR

// Komponen Layout Utama dengan Sidebar
const AppLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login', { replace: true });
    };
    
    // Fungsi untuk mendapatkan style link aktif
    const getLinkStyle = (path) => ({
        ...styles.navLink,
        backgroundColor: location.pathname.startsWith(path) && path !== "/" ? '#e5e7eb' : 'transparent',
        color: location.pathname.startsWith(path) && path !== "/" ? '#111827' : '#374151',
    });

    return (
        <div style={styles.layout}>
            <nav style={styles.sidebar}>
                <div>
                    <h1 style={styles.sidebarHeader}>InvoiceSys</h1>
                    <Link to="/dashboard" style={getLinkStyle('/dashboard')}>Dashboard</Link>
                    <Link to="/invoices" style={getLinkStyle('/invoices')}>Daftar Invoice</Link>
                    <Link to="/invoices/new" style={getLinkStyle('/invoices/new')}>Buat Invoice</Link>
                    <Link to="/reports" style={getLinkStyle('/reports')}>Laporan</Link>
                </div>
                <button onClick={handleLogout} style={styles.logoutButton}>Logout</button>
            </nav>
            <main style={styles.content}>
                <Outlet />
            </main>
        </div>
    );
};


// --- Komponen-komponen Pembantu ---

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

const NotFound = () => <h2>404 - Halaman Tidak Ditemukan</h2>;


// --- Komponen Utama Aplikasi ---

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route 
          path="/" 
          element={
            <PrivateRoute>
              <AppLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} /> 
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="invoices" element={<InvoiceList />} />
          <Route path="invoices/new" element={<InvoiceForm />} />
          <Route path="invoices/edit/:id" element={<InvoiceForm />} />
          <Route path="reports" element={<Report />} />
          {/* RUTE BARU UNTUK PREVIEW INVOICE */}
          <Route path="invoices/preview/:id" element={<InvoicePreview />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}


// CSS-in-JS untuk styling Layout
const styles = {
    layout: {
        display: 'flex',
        fontFamily: 'Arial, sans-serif',
        background: '#f9fafb',
        minHeight: '100vh'
    },
    sidebar: {
        width: '240px',
        background: '#ffffff',
        borderRight: '1px solid #e5e7eb',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box'
    },
    sidebarHeader: {
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '30px',
        color: '#111827'
    },
    navLink: {
        textDecoration: 'none',
        color: '#374151',
        padding: '12px 15px',
        borderRadius: '6px',
        marginBottom: '10px',
        display: 'block',
        transition: 'background-color 0.2s, color 0.2s',
        fontWeight: 500
    },
    logoutButton: {
        marginTop: 'auto',
        width: '100%',
        padding: '12px 15px',
        background: '#fee2e2',
        color: '#dc2626',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        textAlign: 'left',
        fontSize: '15px',
        fontWeight: 500,
        transition: 'background-color 0.2s'
    },
    content: {
        flex: 1,
        padding: '40px',
        overflowY: 'auto'
    }
};

export default App;
